import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row, Table } from "react-bootstrap";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import { GET_REPORT_INCOME_COST } from "../../apollo/dashboard/query";
import { convertCurrency, covertTimeZone, numberFormat } from "../../helper";
import AnimationLoading from "../../components/Animationloading";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import EmptyComponent from "../../components/EmptyComponent";
import { ImCancelCircle } from "react-icons/im";
import { MdOutlineMoneyOff } from "react-icons/md";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { LINEAR_GRADIENT_BG } from "../../const";
import PaginationHelper from "../../components/PaginationHelper";
import { GET_ORDERGROUPS } from "../../apollo/ordergroup/query";
import { useHistory } from "react-router-dom";

export default function Investment() {
    const history = useHistory();
    const [dashboard, setDashboard] = useState(null);
    const [currentStartDate, setCurrentStartDate] = useState(null);
    const [currentEndDate, setCurrentEndDate] = useState(null);
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const [ordergroup, setOrderGroup] = useState(null);
    const [ordergroupTotal, setOrderGroupTotal] = useState(null);

    const [loadDashboard, { data: getDashboard, loading: loadingDashboard }] = useLazyQuery(
        GET_REPORT_INCOME_COST,
        { fetchPolicy: "cache-and-network" }
    );

    const [loadOrderGroup, { data: getordergroupsData, loading: loadingOrderGroups }] = useLazyQuery(
        GET_ORDERGROUPS,
        { fetchPolicy: "cache-and-network" }
    );

    useEffect(() => {
        if (getDashboard) setDashboard(getDashboard.dashboard);
    }, [getDashboard]);

    useEffect(() => {
        if (getordergroupsData) {
            setOrderGroup(getordergroupsData?.orderGroups?.data);
            setOrderGroupTotal(getordergroupsData?.orderGroups?.total);
        }
    }, [getordergroupsData]);

    useEffect(() => {
        _fetchDashboard();
    }, []);

    useEffect(() => {
        _filter();
    }, [currentStartDate, currentEndDate]);

    const handleChangeStartDate = (e) => {
        console.log('FlyReport.js', e.target.value)
        setCurrentStartDate(e.target.value);
    };

    const handleChangeEndDate = (e) => {
        setCurrentEndDate(e.target.value);
    };

    const _filter = async () => {
        try {
            let _where = {
                shop: shopId,
                isDeleted: false
            };

            if (currentStartDate && currentEndDate) {
                _where = {
                    ..._where,
                    createdAt_gte: new Date(moment(currentStartDate).startOf('day').toISOString()),
                    createdAt_lt: new Date(moment(currentEndDate).endOf('day').toISOString())
                };
            }

            await loadDashboard({
                variables: {
                    where: _where,
                    orderBy: "createdAt_DESC"
                }
            });
            console.log('=====', { _where })

            await loadOrderGroup({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                    orderBy: "createdAt_DESC",
                },
            });
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const _fetchDashboard = async () => {
        await loadDashboard({
            variables: {
                where: {
                    shop: shopId,
                },
            },
        });
    };

    const handleCheck = (data) => {
        history.push("/order_detail", {
            state: data,
        })
    }

    return (
        <>
            <BreadCrumbComponent
                txtSecond={`ລາຍງານຕົ້ນທຶນ,ກຳໄລ`}
            />
            <div className="p-4">
                <Row>
                    <Col className="col-2">
                        <Form.Label>ແຕ່ວັນທີ</Form.Label>
                        <Form.Control
                            type="date"
                            value={currentStartDate}
                            onChange={(e) => handleChangeStartDate(e)}
                        />
                    </Col>
                    <Col className="col-2">
                        <Form.Label>ຫາວັນທີ</Form.Label>
                        <Form.Control
                            type="date"
                            value={currentEndDate || ""}
                            onChange={(e) => handleChangeEndDate(e)}
                        />
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col>
                        <Card className="shadow-sm">
                            <div className="d-flex align-items-center justify-content-between p-3">
                                <div>
                                    <RiMoneyDollarCircleLine className="text-primary" size={40} />
                                </div>
                                <div>
                                    <h3 className="mb-0">ຕົ້ນທຶນ</h3>
                                </div>
                            </div>
                            {loadingDashboard && !getDashboard ? (
                                <AnimationLoading />
                            ) : (
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.originPriceLak ?? "0")}</h5>
                                            <p className="mb-0">LAK</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.originPriceBaht ?? "0")}</h5>
                                            <p className="mb-0">BAHT</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.originPriceUsd ?? "0")}</h5>
                                            <p className="mb-0">USD</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            )}
                        </Card>
                    </Col>
                    <Col>
                        <Card className="shadow-sm">
                            <div className="d-flex align-items-center justify-content-between p-3">
                                <div>
                                    <RiMoneyDollarCircleLine className="text-primary" size={40} />
                                </div>
                                <div>
                                    <h3 className="mb-0">ຍອດຂາຍ</h3>
                                </div>
                            </div>
                            {loadingDashboard && !getDashboard ? (
                                <AnimationLoading />
                            ) : (
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.totalPriceLak ?? "0")}</h5>
                                            <p className="mb-0">LAK</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.totalPriceBaht ?? "0")}</h5>
                                            <p className="mb-0">BAHT</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(dashboard?.totalPriceUsd ?? "0")}</h5>
                                            <p className="mb-0">USD</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            )}
                        </Card>
                    </Col>
                    <Col>
                        <Card className="shadow-sm">
                            <div className="d-flex align-items-center justify-content-between p-3">
                                <div>
                                    <RiMoneyDollarCircleLine className="text-primary" size={40} />
                                </div>
                                <div>
                                    <h3 className="mb-0">ກຳໄລ</h3>
                                </div>
                            </div>
                            {loadingDashboard && !getDashboard ? (
                                <AnimationLoading />
                            ) : (
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h5 className="mb-1">{numberFormat(parseFloat(dashboard?.totalPriceLak ?? 0) - parseFloat(dashboard?.originPriceLak ?? "0"))}</h5>
                                            <p className="mb-0">LAK</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(parseFloat(dashboard?.totalPriceBaht ?? 0) - parseFloat(dashboard?.originPriceBaht ?? "0"))}</h5>
                                            <p className="mb-0">BAHT</p>
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{numberFormat(parseFloat(dashboard?.totalPriceUsd ?? 0) - parseFloat(dashboard?.originPriceUsd ?? "0"))}</h5>
                                            <p className="mb-0">USD</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            )}
                        </Card>
                    </Col>
                </Row>

                <div
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        marginTop: "2.5rem"
                    }}>
                    {loadingOrderGroups && !getordergroupsData?.orderGroups ? (
                        <div style={{ height: '70vh' }}>
                            <AnimationLoading />
                        </div>
                    ) : (
                        <>
                            {ordergroup?.length > 0 ? (
                                <Table
                                    hover
                                    style={{
                                        marginTop: "-1em",
                                        borderCollapse: "collapse",
                                        width: "100% ",
                                        cursor: 'pointer'
                                    }}>
                                    <thead
                                        style={{
                                            background: LINEAR_GRADIENT_BG,
                                            borderRadius: " 8px 8px 0px 0px",
                                            color: "#FFFFFF",
                                        }}>
                                        <tr>
                                            <th>ລ/ດ</th>
                                            <th>ເລກທີບິນ</th>
                                            <th>ຊື່ລູກຄ້າ</th>
                                            <th>ນາມສະກຸນ</th>
                                            <th>ເບີໂທ</th>
                                            <th>ຈຳນວນ</th>
                                            <th>ລາຄາລວມ</th>
                                            <th>ແບບການຊຳລະ</th>
                                            <th>ສະຖານະ</th>
                                            <th>ວັນທີ, ເດືອນ, ປີ (ເວລາ)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordergroup
                                            ?.filter((salehis) => salehis.status !== "INDEBTED")
                                            .map((salehis, index) => (
                                                <tr
                                                    key={index}
                                                    className="saleRows"
                                                    onClick={() =>
                                                        handleCheck(salehis)
                                                    }>
                                                    <td>{index + 1 + _limit * (_skip - 1)}</td>
                                                    <td>{salehis?.code ?? ""}</td>
                                                    <td>{salehis?.customerName ?? "-"}</td>
                                                    <td>{salehis?.customerLastName ?? "-"}</td>
                                                    <td>{salehis?.phone ?? "-"}</td>
                                                    <td>{salehis?.amount ?? ""}</td>
                                                    <td>
                                                        {convertCurrency(salehis?.currency) ?? ""}{" "}
                                                        {numberFormat(salehis?.sumPrice) ?? ""}
                                                    </td>
                                                    <td>
                                                        {" "}
                                                        {salehis.payment === "CASH"
                                                            ? "ເງິນສົດ"
                                                            : "ເງິນໂອນ"}
                                                    </td>
                                                    <td
                                                        style={{
                                                            fontWeight: "bold",
                                                            color:
                                                                salehis?.status === "COMPLETED"
                                                                    ? ""
                                                                    : salehis?.status === "NOTYETPAID"
                                                                        ? "blue"
                                                                        : "red",
                                                        }}>
                                                        {salehis?.status === "COMPLETED" ? (
                                                            <div style={{ color: "green" }}>
                                                                ຂາຍສຳເລັດ&ensp;
                                                                <BsFillCheckCircleFill />
                                                            </div>
                                                        ) : salehis?.status === "NOTYETPAID" ? (
                                                            <div style={{ color: "tomato" }}>
                                                                ຍັງບໍ່ທັນຈ່າຍເງີນ&ensp;
                                                                <MdOutlineMoneyOff size={20} />
                                                            </div>
                                                        ) : salehis?.status === "INDEBTED" ? (
                                                            <div style={{ color: "red" }}>
                                                                ຕິດໜິ້&ensp;
                                                                <MdOutlineMoneyOff size={20} />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                ສົ່ງຄືນສິນຄ້າ <ImCancelCircle />
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {covertTimeZone(salehis?.createdAt)}
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <div>
                                    {ordergroup?.length <= 0 && (
                                        <div
                                            style={{
                                                fontSize: "24px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "#6B7280",
                                                fontWeight: "400",
                                            }}>
                                            <EmptyComponent />
                                            <p>ຍັງບໍ່ມີປະຫວັດການຂາຍ !!!</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
                {ordergroupTotal > 0 ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: '1em 2em'
                        }}>
                        {ordergroupTotal && (
                            <div className="show">
                                ກຳລັງສະແດງ {50 * _skip - 49}-
                                {50 * _skip > ordergroupTotal ? ordergroupTotal : 50 * _skip}{" "}
                                ຈາກ {ordergroupTotal}
                            </div>
                        )}
                        <div>{Pagination_helper(ordergroupTotal, "", ``)}</div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    );
}
